//import { Appointment } from './types/appointment.ts';
import { Card, Badge } from 'react-bootstrap';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';




export const AppointmentCard = ({ appointment, compact = false }) => {


  const statusConfig = {
    confirmed: {
      label: 'Confirmado',
      badgeClass: 'badge-confirmed',
      cardClass: 'appointment-confirmed',
    },
    pending: {
      label: 'Pendente',
      badgeClass: 'badge-pending',
      cardClass: 'appointment-pending',
    },
    cancelled: {
      label: 'Cancelado',
      badgeClass: 'badge-cancelled',
      cardClass: 'appointment-cancelled',
    },
  };
  const status = statusConfig[appointment?.status];

  if (compact) {
    return (
      <div className={`appointment-compact ${status.cardClass}`}>
        <div className="fw-medium text-truncate">{appointment?.clientName}</div>
        <div className="text-muted text-truncate">
          {appointment?.startTime} - {appointment?.function}
        </div>
      </div>
    );
  }

  return (
    <Card className={`shadow-sm h-100 ${status.cardClass}`}>
      <Card.Body className="p-3">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <h6 className="mb-0 fw-semibold">{appointment?.clientName}</h6>
            <small className="text-muted">{appointment?.professional}</small>
          </div>
          <Badge className={status.badgeClass}>{status.label}</Badge>
        </div>

        <div className="small">
          <div className="d-flex align-items-center gap-2 text-muted mb-1">
            <FontAwesomeIcon icon={faClock} />
            <span>
              {format(appointment.date, "dd 'de' MMMM", { locale: ptBR })} • {appointment.startTime} - {appointment.endTime}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2 text-muted mb-1">
            <FontAwesomeIcon icon={faClock} />
            <span>{appointment.function}</span>
          </div>

          <div className="d-flex align-items-center gap-2 text-muted mb-1">
             <FontAwesomeIcon icon={faPhone} />
            <span>{appointment.clientPhone}</span>
          </div>

          <div className="d-flex align-items-center gap-2 text-muted">
              <FontAwesomeIcon icon={faEnvelope} />
            <span>{appointment.clientEmail}</span>
          </div>

          {appointment.notes && (
            <div className="border-top mt-2 pt-2">
              <small className="text-muted fst-italic">{appointment.notes}</small>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
